
import { Vue, Component } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import { IAPPSTATE } from '@/store/state.d';

@Component
export default class MenuAvatar extends Vue {
  @State app!: IAPPSTATE

  @Action('user/loginOut') loginOut!: Function

  private timer: any = null;

  loginout() {
    this.alert('此操作将退出系统，是否继续?', {
      iconType: 'warning',
      loading: true,
    }).then(() => {
      this.msg('系统退出中, 工作辛苦啦~', 'loading');
      this.timer = setTimeout(() => this.loginOut()
        .then(() => this.$log({
          title: '用户退出 - 完成',
          component: 'Home-tHeader-avatar',
        })), 2200);
    });
  }

  destoryed() {
    if (this.timer) clearTimeout(this.timer);
  }
}
